module.exports = __webpack_public_path__ + "static/media/projectManager.59400e37.svg";